module.exports = __webpack_public_path__ + "static/media/clean_full_page_ios.002d4f55.png";